import { computed, state } from 'ccstate'
import { apiClient$ } from '../infra/apiClient'

export const historyDirty$ = state(1)

export const searchHistory$ = computed(async (get) => {
  get(historyDirty$)
  const apiClient = get(apiClient$)
  const result = await apiClient.getApi('getSearchHistory', {})
  return result.history
})
